import React from "react";
import "./Tech.css";

function Tech() {
    const steps = [
        { id: 1, label: "Clustering Farmers" },
        { id: 2, label: "Varietal Check" },
        { id: 3, label: "Procurement by FPOs" },
        { id: 4, label: "Primary Processing" },
        { id: 5, label: "Quality Check" },
        { id: 6, label: "Market Linkage" },
        { id: 7, label: "Logistics Management" },
        { id: 8, label: "Payment Terms" },
    ];

    const features = [
        {
            img: "/Images/empower3.png",
            title: "FPO Centric Tools",
            copy:
                "Tools tailored to FPOs include support for supply chain logistics, centralized records management, and financial tracking, empowering FPOs to deliver consistent, high-quality support to member farmers.",
        },
        {
            img: "/Images/empower2.png",
            title: "Transparent Market Access",
            copy:
                "By connecting directly with buyers, FPOs can avoid intermediary fees, increasing profitability while ensuring fresh, high-quality produce reaches consumers.",
        },
        {
            img: "/Images/empower1.png",
            title: "Seamless Mobile Dashboard",
            copy:
                "A user-friendly mobile app and webapp brings KrishiYan’s resources directly to farmers, enabling on-the-go access to crop support, updates, and advisory services.",
        },
    ];


    return (
        <section id="tech" className="min-h-screen">
            <h1 className="heading ">How Krishiyan Works</h1>
            <div className="divider"></div>
            <div className="timeline-container">
                {steps.map((step, index) => (
                    <div key={step.id} className="timeline-step">
                        <div className="circle">{step.id}</div>
                        <div className="vertical_line"></div>
                        <div className="label"><p className="label-text">{step.label}</p></div>
                        {index < steps.length - 1 && <div className="line"></div>}
                    </div>
                ))}
            </div>

            {/* Cards */}
            <section className="py-12 px-4 sm:px-6 lg:px-24">
                <h2 className="text-3xl sm:text-4xl font-bold text-[#3FC041] text-center mb-10">
                    Key Features of KrishiYan Platform
                </h2>
                <div className='h-1 w-14 rounded-xl bg-[#616161] mx-auto xl:mt-[20px] xl:mb-[30px]'></div>
                <div className="flex flex-wrap justify-center gap-8">
                    {features.map(({ img, title, copy }) => (
                        <div
                            key={title}
                            className="relative w-full max-w-sm sm:w-1/2 md:w-1/3"
                        >
                            {/* Overlapping icon: top-center on mobile, center-left on desktop */}
                            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2
                            md:top-1/2 md:left-0 md:-translate-x-1/2 md:-translate-y-1/2
                            z-10">
                                <img
                                    src={img}
                                    alt={title}
                                    className="h-20 w-20"
                                />
                            </div>

                            {/* Colored card: extra top padding on mobile for icon overlap, left padding on desktop */}
                            <div className="bg-[#3390ff] text-white pt-12 pb-6 px-6
                            md:pr-6 md:pl-12 rounded-lg flex flex-col h-full">
                                <h3 className="text-xl sm:text-xl text-center mb-3">
                                    {title}
                                </h3>
                                <p className="text-lg sm:text-base leading-relaxed text-left flex-grow">
                                    {copy}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </section>
    );
}

export default Tech;
